export enum FeedbackOption {
    INCORRECT_INFO = "incorrect_info",
    INCORRECT_IMAGES = "incorrect_images",
    INCORRECT_METADATA = "incorrect_metadata",
    TOO_DIFFICULT = "too_difficult",
    TOO_SIMPLE = "too_simple",
    NO_ANSWER = "no_answer",
    PRONUNCIATION = "pronunciation",
    MISSING_ALERTS = "missing_alerts",
    CHECKLIST_NEEDED = "checklist_needed",
    OTHER = "other"
}

// Add new enum for feedback types
export enum FeedbackType {
    POSITIVE = "positive",
    NEGATIVE = "negative"
} 